export const useCustomScrollLock = ({ activeScrollLock }) => {
  const scrollPosition = ref(0);

  const disableScroll = () => {
    scrollPosition.value = window.scrollY; // 현재 스크롤 위치 저장
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition.value}px`;
    document.body.style.width = '100%';
  };

  const enableScroll = () => {
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollPosition.value); // 스크롤 위치 복구
  };

  // activeScrollLock 값 감시 및 스크롤 제어
  watch(activeScrollLock, (isActive) => {
    if (isActive) {
      disableScroll();
    } else {
      enableScroll();
    }
  });

  // 컴포넌트 언마운트 시 lock 상태였다면 안전하게 해제
  // (팝업이 열린 상태에서 라우터 이동 시 body가 fixed로 남아 새 페이지가 흰 화면이 되는 문제 방지)
  onUnmounted(() => {
    if (document.body.style.position === 'fixed') {
      enableScroll();
    }
  });

  return {
    disableScroll,
    enableScroll,
  };
};
